module.exports = __webpack_public_path__ + "img/code-reviewer.c272d2b1.webp";